import { useMutation } from '@tanstack/react-query'
import { api } from '@api'

const inviteGhostToJoin = async (ghostProfileId: string): Promise<void> => {
  await api.post(`/ghost-profiles/${ghostProfileId}/invite-to-join`)
}

export const useInviteGhostToJoin = () => {
  return useMutation<void, Error, string>({
    mutationFn: inviteGhostToJoin,
  })
}
